import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useLocalization } from '../../../context/Localization/localization';
import { Heading } from '../../../controls/Heading/Heading';
import { versionNumber } from '../../../helpers/version';
import { useKioskState } from '../../../context/Kiosk/kiosk';
import { Spacer } from '../../../controls/Spacer/Spacer';

import css from './KioskInformation.module.scss';
import { GMRoundedIcon, GMSizedIcon } from '../../../controls/Icon';
import { GMTitle } from '../../../controls/Title';
interface IProps { }

export const KioskInformation: React.FC<IProps> = React.memo((props) => {
    const Localization = useLocalization();
    const version: string = useMemo(() => versionNumber(), []);
    const { machineId, kioskTypeName } = useKioskState();

    return (
        <>
            <Heading
                primaryHeading={Localization.KioskInformation}
                roundedIcon={
                    <GMRoundedIcon roundedBackgroundSize={'large'} themeType={'secondary'}>
                        <GMSizedIcon iconType={'Information'} iconSize={'extraLarge'} />
                    </GMRoundedIcon>
                }
                showMustache
            />
            <Spacer />
            <div>
                <div className={classNames(css.infoBox, css.titleBox)}>
                    <div className={css.information}>
                        <div className={css.icon}>
                            <GMSizedIcon iconSize={'large'} iconType={'DMS'} />
                        </div>
                        <div className={css.content}>
                            <h4 className={css.title}>{Localization.formatString(Localization.GoMotoKiosk, kioskTypeName)}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classNames(css.infoBox, css.kioskBox)}>
                <div className={css.information}>
                    <div className={css.content}>
                        <GMTitle headerLevel={5}>{Localization.formatString(Localization.ReleaseVersionNumber, version)}</GMTitle>
                        {machineId && <GMTitle headerLevel={5}>{Localization.formatString('{0} {1}', Localization.MachineId, machineId)}</GMTitle>}
                    </div>
                </div>
            </div>
        </>
    );
});
